import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const PageHeader = ({
  pageHeader,
  cardHeaderDetails,
  showCycle = false,
  showTimeFrame = false,
  showBu = true,
  displayInfo = false,
  infoMsg = '',
  showLoader
}) => {
  const selectedBu = useSelector((state) => state?.cycle?.selectedBu);
  return (
    <Box>
      <Stack direction="row" justifyContent={'space-between'}>
        {/* page header */}
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Typography variant="h4">{pageHeader}</Typography>
          {displayInfo && (
            <span
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                padding: '2px 16px',
                gap: '8px',
                background: 'rgb(192 221 229 / 42%)',
                borderRadius: '8px',
                // marginBottom: '20px',
                fontSize: '12px',
                // marginRight: '20vw',
                width: 'fit-content'
              }}>
              <InfoOutlinedIcon sx={{ fontSize: '16px', width: '16px', height: '14px' }} />
              <span>{infoMsg}</span>
            </span>
          )}
        </div>
        {/* cycle and timeframe component */}
        <Stack
          direction="row"
          gap="2rem"
          sx={{
            alignContent: 'center',
            alignItems: 'center',
            backgroundColor:
              pageHeader === 'Feedback Collation' || pageHeader === 'Decision Making Central'
                ? 'none'
                : '#FBFCFE',
            padding: '4px',
            minWidth: '130px',
            minHeight: '40px',
            borderRadius: '8px'
          }}>
          {/* BU block */}
          {showBu && (
            <Stack direction={'column'} alignItems="center">
              {/* Adjusted: allows this block to take available space */}
              <Typography variant="extraSmall" fontWeight={400} sx={{ color: '#616161' }}>
                Current BU
              </Typography>
              <Typography variant="extraSmall" fontWeight={700}>
                {selectedBu}
              </Typography>
            </Stack>
          )}

          {/* Cycle block */}
          {showCycle && (
            <Stack container direction={'column'} alignItems="center">
              {/* Adjusted: allows this block to take available space */}
              <Typography variant="extraSmall" fontWeight={400} sx={{ color: '#616161' }}>
                Current cycle
              </Typography>
              <Typography variant="extraSmall" fontWeight={700}>
                {cardHeaderDetails?.cycleName ? cardHeaderDetails?.cycleName : 'NA'}
              </Typography>
            </Stack>
          )}

          {/* TimeFrame block */}
          {showTimeFrame && (
            <Stack direction={'column'} alignItems={'center'}>
              <Typography variant="extraSmall" fontWeight={400} sx={{ color: '#616161' }}>
                Timeframe (Year & Period)
              </Typography>
              {showLoader ? (
                <CircularProgress size={20} />
              ) : (
                <Typography variant="extraSmall" fontWeight={700}>
                  {cardHeaderDetails?.startTimePeriod} - {cardHeaderDetails?.endTimePeriod}
                </Typography>
              )}
            </Stack>
          )}

          {/* SKUs block added */}
          {pageHeader === 'Portfolio Summary' && (
            <Stack container direction={'column'} alignItems="center">
              <Typography variant="extraSmall" fontWeight={400} sx={{ color: '#616161' }}>
                SKUs
              </Typography>
              <Typography variant="extraSmall" fontWeight={700}>
                {cardHeaderDetails?.cycleSKUCount} SKUs
              </Typography>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default PageHeader;
